import React, { useState,  } from 'react'



//Css
import '../../Css/DashboardPage.scss'

//Assets
import LogoFpj from '../../Assets/Logo/LogoFPJ.png'
import LogoFpj_Black from '../../Assets/Logo/LogoFPJ_Black.png'

//Tempplates
import LoginForm from '../Templates/DashboardTemplate/LoginForm'
import RegisterForm from '../Templates/DashboardTemplate/RegisterForm'
import LoadingTemplate from '../Templates/Loading'


function DashboardPage(){
    
    const [OpenRegister, setOpenRegister] = useState(false)
    const [Loading, setLoading] = useState(false)

        return(
            <section>
                {Loading && <LoadingTemplate/> }
                
                <div className="container">
                   <div className="card">
                       <div className="part title">
                           <div className="imgWrapper">
                                <img src={LogoFpj} />
                                <h1>Komunitas Film Pendek Jakarta</h1>
                           </div>
                           <div className="introduce">
                               <div>
                                    <h2>Create Your Movie Journey</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatem, odio!</p>
                                    
                               </div>
                           </div>
                           <div className="footer">
                                <div className="sosmed">
                                    <ul>
                                        <li><a href="#"><i className="fab fa-instagram-square"></i></a></li>
                                        <li><a href="#"><i className="fab fa-youtube-square"></i></a></li>
                                        <li><a href="#"><i className="fab fa-facebook-square"></i></a></li>
                                    </ul>
                                </div>
                                <div className="author">
                                    Powered By <a href="#">@m.hafiz.b</a><br/><i>Beta version 1.0.0</i>
                                </div>
                           </div>
                       </div>
                       <div className="part desc descSlider">
                            <div className="imgWrapper_desc">
                                <img src={LogoFpj_Black} alt="" srcset=""/>
                                <h1>Komunitas Film Pendek Jakarta</h1>
                            </div>
                           <div className= {OpenRegister == false ? "slider": "slider moveSlider"}>
                                <div className="pages">
                                    <LoginForm 
                                        setTriggeregister = {()=>setOpenRegister(true)} 
                                        Loading = {(status)=>setLoading(status)}
                                    />
                                </div>
                                <div className="pages ">
                                    <RegisterForm 
                                        setTriggeregister={()=>setOpenRegister(false)}
                                        Loading = {(status)=>setLoading(status)}
                                    />
                                </div>  
                           </div>
                           
                           <div className="footer">
                                <div className="sosmed">
                                    <ul>
                                        <li><a href="#"><i className="fab fa-instagram-square"></i></a></li>
                                        <li><a href="#"><i className="fab fa-youtube-square"></i></a></li>
                                        <li><a href="#"><i className="fab fa-facebook-square"></i></a></li>
                                    </ul>
                                </div>
                                <div className="author">
                                    Powered By <a href="#">@m.hafiz.b</a><br/><i>Beta version 1.0.0</i>
                                </div>
                           </div>
                       </div>
                       
                   </div>
                </div>
            </section>
           
        )
    
}

export default DashboardPage;